import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { createSelector } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';
import { PublisherTagsAndPromotionalTypes } from 'app/modules/main/models/publisher-tags-and-promotional-types';
import { PublisherTagsAndPromotionalTypesState } from 'app/modules/communication-centre/advertiser/store/publisher-tags-and-promotional-types/publisher-tags-and-promotional-types.state';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PublisherTagsAndPromotionalTypesSelectors {

  static readonly FEATURE = 'PublisherTagsAndPromotionalTypes';

  private readonly feature = createFeatureSelector<PublisherTagsAndPromotionalTypesState>(
    PublisherTagsAndPromotionalTypesSelectors.FEATURE
  );

  private readonly publisherTagsAndPromotionalTypes = createSelector(
    this.feature,
    (state: PublisherTagsAndPromotionalTypesState) => state.publisherTagsAndPromotionalTypes
  );

  private readonly publisherTagsAndPromotionalTypesLoaded = createSelector(
    this.feature,
    (state: PublisherTagsAndPromotionalTypesState) => state.publisherTagsAndPromotionalTypesLoaded
  );

  constructor(
    private readonly store: Store<PublisherTagsAndPromotionalTypesState>
  ) {
  }

  public havePublisherTagsAndPromotionalTypesLoaded(): Observable<boolean> {
    return this.store.select(this.publisherTagsAndPromotionalTypesLoaded);
  }

  public onPublisherTagsAndPromotionalTypesLoaded(): Observable<boolean> {

    return this.havePublisherTagsAndPromotionalTypesLoaded()
      .pipe(filter(x => !!x));
  }

  public getPublisherTagsAndPromotionalTypes(): Observable<PublisherTagsAndPromotionalTypes> {

    return this.onPublisherTagsAndPromotionalTypesLoaded()
      .pipe(switchMap(() => this.store.select(this.publisherTagsAndPromotionalTypes)));
  }

}
